
//   async function checkSubscription(shop)
//   {
//     try
//     {
//       const res = await fetch(`/apps/calculator/get-subscription`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json", // JSON
//         },
//         body: JSON.stringify({ shop: shop }),
//       });
//       const data = await res.json();
//       let text = "";

//       if ((data.subscription.subscriptionPlan == 'Basic') ||(data.subscription.subscriptionPlan == 'Unlimited'))
//       {
//         text = `✅ Active subscription: ${data.subscription.subscriptionPlan || "Unknown"}`;
//       }
//       else
//       {
//         text = "⚠️ No active subscription";
//       }
//       const block = document.getElementById('coverage-calculator-block');
//       if (!data.activateBlock)
//         block.style.display = 'none';
//       console.log(text);
//       console.log(data.subscription.subscriptionPlan);
//     }
//     catch (e)
//     {
//       console.error("Error fetching subscription", e);
//     }
//   }

document.addEventListener("DOMContentLoaded", function()
{
    const calc = document.getElementById("coverage-calculator-block");
    const areaInput = document.getElementById("areaInput");

  

    if (!calc || !areaInput)
    {
      console.error("Product Calculator block not found");
      return;
    }
   // result.innerText = "";

    let productWidth = parseFloat(calc.getAttribute("productwidth")) || 0;
    let productLength = parseFloat(calc.getAttribute("productlength")) || 0;
    let productStrength = parseFloat(calc.getAttribute("productstrength")) || 0;
    let packagesize = parseInt(calc.getAttribute("packagesize")) || 0;
    let rutschfestigkeit = calc.getAttribute("rutschfestigkeit");
    let unitSystem = parseInt(calc.getAttribute("unitSystem")) || 1;

    //checkSubscription(calc.getAttribute("shopdomain")); // ignore for now

    let variantPicker = document.querySelector("variant-picker");
    let variantPickerType = "picker";

    if (variantPicker == null)
    {
      variantPicker = document.querySelector("variant-selects");
      variantPickerType = "selects";
    }

    // let variantId = null;
    // if (variantPicker)
    // {
    //   const selectedOption = variantPicker.querySelector(
    //     "input[type='radio']:checked, select"
    //   );

    //   if (selectedOption)
    //   {
    //     if (variantPickerType == "picker")
    //       variantId = selectedOption.getAttribute("data-variant-id");     
    //     if (variantPickerType == "selects")          
    //       variantId = getVariantID(selectedOption.getAttribute("value"));        
    //   }

    //   variantPicker.addEventListener("change", (event) => {
    //     if (variantPickerType == "picker")
    //       variantId = event.target.getAttribute("data-variant-id");
    //     if (variantPickerType == "selects")         
    //       variantId = getVariantID(event.target.getAttribute("value")); 

    //     setVariantValues();
    //     showDimensions();
    //     calculate();
    //   });
    // }
    // LX 07.12.25: replaced with below

    let variantId = getCurrentVariantId();

    if (variantPicker) {
      variantPicker.addEventListener("change", () => {
        variantId = getCurrentVariantId();
        setVariantValues();
        showDimensions();
        calculate();
      });
    }


    areaInput.addEventListener("input", function()
    {
      calculate();
    });

    // LX 07.12.25: getcurrentvariant from input
    function getCurrentVariantId() {
      const idInput = document.querySelector('form[action^="/cart/add"] input[name="id"]');
      return idInput ? idInput.value : null;
    }


    function getVariantID(name)
    {
      const metafields = JSON.parse(document.getElementById("variant-metafields-json").textContent);
      for (const key in metafields) 
      {
        const value = metafields[key];
        if (value.title == name)
          return key;        
      }
    }

    function setVariantValues()
    {
      // if (!variantPicker)
      //   return;
      // LX 07.12.25 changed to below
        if (!variantId) return;

      const metafields = JSON.parse(document.getElementById("variant-metafields-json").textContent);
      const variantFields = metafields[variantId] || null;
    
      if (variantFields != null)
      {
        productWidth = parseFloat(variantFields.productwidth) || parseFloat(calc.getAttribute("productwidth"));
        productLength = parseFloat(variantFields.productlength) || parseFloat(calc.getAttribute("productlength"));
        productStrength = parseFloat(variantFields.productstrength) || parseFloat(calc.getAttribute("productstrength"));
        packagesize = parseInt(variantFields.packagesize) || parseFloat(calc.getAttribute("packagesize"));
        rutschfestigkeit = variantFields.rutschfestigkeit || calc.getAttribute("rutschfestigkeit");
      }
    }

    function calculate()
    {
     
      if (parseFloat(areaInput.value) <= 0)
        return;
     
      const coverage = (productWidth / 100) * (productLength / 100) * packagesize;
      let area = parseFloat(areaInput.value);


      if (!isNaN(area) && area > 0 && coverage > 0)
      {
        let packages = Math.ceil(area / coverage);

        document.getElementById("packageCount").innerText = packages;
        // document.getElementById("productwaste").innerText = productwaste;
        document.getElementById("coverage").innerText = (packages * coverage).toFixed(2);

        document.getElementById('estimate').style.display = 'block';
        // update quantity field for Add to Cart
        let qtyField = document.querySelector("input[name='quantity']");
        if (qtyField) qtyField.value = packages;

        // if (!wasteInput.checked)
        // {
        //   document.getElementById('preWaste').style.display = 'none';
        //   document.getElementById('postWaste').style.display = 'none';
        //   document.getElementById('productwaste').style.display = 'none';
        // }
        // else
        // {
        //   document.getElementById('preWaste').style.display = 'inline';
        //   document.getElementById('postWaste').style.display = 'inline';
        //   document.getElementById('productwaste').style.display = 'inline';
        // }
      }
      else
      {
        //result.innerText = "Debug:Data wrong";
      }
    }

    function showDimensions() {
      if (productWidth)
      {
        document.getElementById("productWidth").innerHTML = "<b>Breite:</b> " + productWidth + "cm";
      } else {
        document.getElementById("productWidth").innerHTML = "<b>Breite:</b> "
      }
      if (productLength)
      {
        document.getElementById("productLength").innerHTML = "<b>Länge:</b> " + productLength + "cm";
      } else {
        document.getElementById("productLength").innerHTML = "<b>Länge:</b> "
      }
      if (productStrength)
      {
        document.getElementById("productStrength").innerHTML = "<b>Stärke:</b> " + productStrength + "mm";
      } else {
        document.getElementById("productStrength").innerHTML = "<b>Stärke:</b> "
      }
      if (rutschfestigkeit)
      {
        document.getElementById("rutschfestigkeit").innerHTML = "<b>Rutschfestigkeit:</b> " + rutschfestigkeit;
      } else {
        document.getElementById("rutschfestigkeit").innerHTML = ""
      }
      if (packagesize)
      {
        document.getElementById("packagesize").innerHTML = "<b>Anzahl pro Packung:</b> " + packagesize + " Stück";
      } else {
        document.getElementById("packagesize").innerHTML = "<b>Anzahl pro Packung:</b> "
      }
      if (productWidth && productLength && packagesize)
      {
        let productPackageM2 = (productWidth/100*productLength/100)*packagesize;
        document.getElementById("productPackageM2").innerHTML = "<b>1 Packung:</b> " + productPackageM2.toFixed(2) + " m²";
      } else {
        document.getElementById("productPackageM2").innerHTML = "<b>1 Packung:</b> "
      }
    }

    setVariantValues();
    calculate();
    showDimensions();

});
